export default function useProductResourceVisibility(product) {
const inspirationVisible = (product) => ( product?.app_photos?.length > 0 );
const resourcesVisible = ((product) => { return ((product.more_about_text && product.more_about_text !== '') || 
                                           (Object.values(product.attributes || {}).filter((d, i) => d?.length > 0 ).length > 0)  ||
                                           (Object.values(product.downloads || {}).filter((d, i) => d?.length > 0 ).length > 0) ) 
                                           }); 

 const collectionsVisible = (product) => ( product?.collections?.length > 0 );
 const similarProductsVisible = (product) => ( product?.similar_products?.products.length > 0 );
 const compatibleProductsVisible = (product) => ( product?.compatible_products?.products.length > 0 );
 const accessoryProductsVisible = (product) => ( product?.accessories?.products.length > 0 );

 const configuratorVisible = (product) => ( product.configuratorExists)
return {
   inspirationVisible: inspirationVisible(product), 
   resourcesVisible: resourcesVisible(product),  
   collectionsVisible: collectionsVisible(product), 
   similarProductsVisible: similarProductsVisible(product), 
   accessoryProductsVisible: accessoryProductsVisible(product), 
   compatibleProductsVisible: compatibleProductsVisible(product), 
   configuratorVisible: configuratorVisible(product) 
 }
}
